import React from "react";

export default function NoPage(){
    return(
        <div className="no-page">
            <h3>Error Back to Home page</h3>
            <a href="/">back to safely</a>
        </div>
    )
}